/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { TextField, Autocomplete } from "@mui/material";
import ConvoyDialog from "../../../components/ConvoyDialog";
import { useUpdateUserManager } from "../../../api/users";

const UpdateMangerDialog = ({
  open,
  user,
  people,
  resetDialog,
  displayNotification,
  callback,
}) => {
  const [payload, setPayload] = useState({});

  const {
    postData: updateUserManager,
    response: updateUserManagerResp,
    responseStatus: updateUserManagerStatus,
  } = useUpdateUserManager();

  useEffect(() => {
    if (!open) {
      setPayload({});
    }
  }, [open]);

  useEffect(() => {
    displayNotification(
      updateUserManagerResp,
      updateUserManagerStatus,
      callback
    );
  }, [updateUserManagerResp, updateUserManagerStatus]);

  const handleDialogConfirm = () => {
    console.log(user);
    updateUserManager(payload, user?.id);
    resetDialog();
  };

  const isFormValid = () => {
    return payload?.managerEmailId;
  };

  return (
    <ConvoyDialog
      open={open}
      title={`Update Manager for ${user?.name}`}
      handleDialogConfirm={handleDialogConfirm}
      resetDialog={resetDialog}
      onCancelClick={resetDialog}
      disabled={!isFormValid()}
    >
      <UpdateManagerField
        payload={payload}
        setPayload={setPayload}
        people={people}
      />
    </ConvoyDialog>
  );
};

export const UpdateManagerField = ({ payload, setPayload, people }) => {
  return (
    <Autocomplete
      noOptionsText="No Manager available"
      fullWidth
      options={people?.map((person) => person.emailId) || []}
      value={payload?.managerEmailId || ""}
      onChange={(event, newValue) => {
        setPayload((prev) => ({
          ...prev,
          managerEmailId: newValue || "",
        }));
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Manager Email Id"
          color="secondary"
          placeholder="Select Manager"
        />
      )}
    />
  );
};

export default UpdateMangerDialog;
